module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-ExtraBold.fb163ed.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-ExtraBold.eot
// module id = uyEY
// module chunks = 6